import { apiSlice } from "../../../app/services/apiSlice";
import { getFullName } from "../../kanban/components/hiringListing/hiringUtils";


const TRANSFER_RESPONSIBILITIES_URL = 'responsibilities/';
const USER_URL = 'users/';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getResponsibilities: builder.query({
        query: (params) => ({
          url: `${TRANSFER_RESPONSIBILITIES_URL}pending/tasks`,
          params,
        }),
      }),
      getAllUserByRoles: builder.mutation({
        query: (params) => ({
          url: `${TRANSFER_RESPONSIBILITIES_URL}${USER_URL}role-base`,
          params,
        }),
        transformResponse: (responseData) => {
          responseData.options = responseData?.map((account) => ({
            ...account,
            value: account?.id,
            title: getFullName(account),
          }));
          responseData.total = responseData?.totalCount;
          responseData.page = responseData.currentPage;
          return responseData || {};
        },
      }),

      transferHiringPlane: builder.mutation({
        query: (data) => ({
          url: `${TRANSFER_RESPONSIBILITIES_URL}transfer/tasks`,
          method: 'POST',
          body: {
            ...data,
          },
        }),
      }),
      getAssignedTasks: builder.query({
        query: (params) => ({
          url: `${TRANSFER_RESPONSIBILITIES_URL}assigned/tasks`,
          params,
        }),
      }),
      getUserTaskDetails: builder.mutation({
        query: ({id}) => ({
          url: `${TRANSFER_RESPONSIBILITIES_URL}tasks/${id}`,
          method:'GET',
        }),
      }),
      deleteUserFromResponsibility: builder.mutation({
        query: ({id}) => ({
          url: `${TRANSFER_RESPONSIBILITIES_URL}user/${id}`,
          method:'DELETE',
        }),
      }),
     
  }),

});

export const {
useGetResponsibilitiesQuery,
useGetAssignedTasksQuery,
useGetAllUserByRolesMutation,
useTransferHiringPlaneMutation,
useGetUserTaskDetailsMutation,
useDeleteUserFromResponsibilityMutation
} = extendedApiSlice;
